import { Route, Routes } from "react-router-dom"
import { Catalog } from "../pages/main"
import { ServiceProvider } from "../context"
import { FormCatalog } from "../pages/form"



const CatalogRoute = () => {
  return (
    <ServiceProvider>
      <Routes>
        <Route path="/" element={<Catalog />} />
        <Route path="create" element={<FormCatalog />} />
        <Route path="edit/:id" element={<FormCatalog />} />
      </Routes>
    </ServiceProvider>
  )
}

export default CatalogRoute
